import { useQuery } from '@hooks/reactQuery';

import { getMoBranch } from '@api/configurationComparison';

import { formatDate } from '@utils/date';

import { TMoBranchDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { MO_BRANCH } from '@constants/queryKeys';

export const useQueryMoBranch = (params: TMoBranchDTO) => {
	const {
		comparisonId,
		page,
		pageSize,
		sortDirection,
		sortFieldName,
		delta,
		configId,
		siteId,
		gnbId,
		paramName,
		managedObjects,
		searchValue,
	} = params;

	const {
		data: branch,
		isLoading: isLoadingBranch,
		isFetching: isFetchingBranch,
	} = useQuery({
		queryKey: [
			MO_BRANCH,
			page,
			pageSize,
			searchValue,
			sortDirection,
			sortFieldName,
			delta,
			configId,
			siteId,
			gnbId,
			paramName,
			managedObjects,
		],
		queryFn: () => getMoBranch({
			comparisonId,
			page,
			pageSize,
			sortDirection,
			sortFieldName: sortFieldName?.replace('_', '.'),
			configId,
			delta,
			siteId,
			gnbId,
			searchValue,
			paramName,
			managedObjects,
		}),
		select: (data) => {
			const items = data?.moNames
				? data.rows?.items.map((item) => ({
					...item,
					...item.managedObjects?.reduce((acc, moItem) => ({
						...acc,
						[moItem.moName]: moItem.moId,
					}), {}),
				}))
				: data.rows?.items;

			return { ...data, rows: { items, count: data?.rows?.count || 0 } };
		},
		refetchOnWindowFocus: false,
		refetchOnmount: false,
	});

	return {
		branch: branch?.rows?.items || [],
		moNames: branch?.moNames || [],
		countOfRecords: branch?.rows?.count || 0,
		dataSourceCreatedAtFirst: formatDate(branch?.dataSourceCreatedAtFirst || ''),
		dataSourceCreatedAtSecond: formatDate(branch?.dataSourceCreatedAtSecond || ''),
		isLoadingBranch: isLoadingBranch || isFetchingBranch,
	};
};
